/**
 * Verifica se existe uma NFS-e EMITIDA (issued) vinculada a um documento de
 * origem. Usado para bloquear edição/exclusão/estorno de documentos que já
 * possuem nota fiscal ativa (a nota deve ser cancelada antes).
 *
 * @param {object} http Instância do $http (axios)
 * @param {string} originType Tipo da origem (ex.: 'financial_transaction')
 * @param {string} originId Id do documento de origem
 * @returns {Promise<boolean>}
 */
export default async function hasIssuedFiscalDocument(http, originType, originId) {
  if (!originType || !originId) return false;

  try {
    const { data } = await http.get('/fiscal-documents', {
      params: {
        origin: `${originType}:${originId}`,
        status: 'issued',
        limit: 1,
      },
    });
    return !!(data && data.items && data.items.length > 0);
  } catch (e) {
    // Falha na verificação não bloqueia a ação (guarda apenas de UX).
    return false;
  }
}
